import { arrayContainsValues } from '@shared/core/types/common';

const appleNetworkTypes: ApplePayJS.SupportedNetorks = [
    'visa', 'masterCard', 'amex', 'discover', 'jcb', 'chinaUnionPay', 'interac', 'privateLabel'
];

export const appleNetworkTypesType = arrayContainsValues(...appleNetworkTypes);
